import React, { useState } from "react";
import { motion } from "framer-motion";

const contactInfo = [
  {
    icon: (
      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
      </svg>
    ),
    label: "Address",
    lines: ["Kampala, Uganda"],
  },
  {
    icon: (
      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.61 21 3 13.39 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.25 1.01l-2.2 2.2z"/>
      </svg>
    ),
    label: "Phone",
    lines: [
      // { text: "Mobile: +256 762 919 197", href: "tel:+256762919197" },
      { text: "Hotline: +256 200 937 979", href: "tel:+256200937979" },
    ],
  },
  {
    icon: (
      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
      </svg>
    ),
    label: "Email",
    lines: [
      { text: "info@smartcool.co.ug",  href: "mailto:info@smartcool.co.ug"  },
      { text: "sales@smartcool.co.ug", href: "mailto:sales@smartcool.co.ug" },
    ],
  },
  {
    icon: (
      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2a10 10 0 100 20A10 10 0 0012 2zm.5 5v6l4.5 2.7-.75 1.23L11 13.5V7h1.5z"/>
      </svg>
    ),
    label: "Working Time",
    lines: ["Monday–Friday: 8:00am – 6:00pm", "Saturday–Sunday: 9:00am – 3:00pm"],
  },
];

const formFields = [
  { name: "name",     label: "Your name",          type: "text",  placeholder: "abc" },
  { name: "email",    label: "Email address",       type: "email", placeholder: "Abc@def.com" },
  { name: "phone",    label: "Phone Number",        type: "tel",   placeholder: "This is required" },
  { name: "location", label: "Your Location / Area",type: "text",  placeholder: "This is required" },
];

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", location: "", message: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    if (!form.name || !form.email || !form.phone || !form.message) {
      alert("Please fill in all required fields.");
      return;
    }

    setStatus("sending");

    fetch("/send-mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name:     form.name,
        email:    form.email,
        phone:    form.phone,
        location: form.location,
        message:  form.message,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setStatus("success");
          setForm({ name: "", email: "", phone: "", location: "", message: "" });
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  };

  return (
    <motion.div
      className="font-poppins"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >

      {/* ── HERO BANNER — text drops in from top ── */}
      <section className="py-12 sm:py-16 text-center text-white" style={{ backgroundColor: "#0F1030" }}>
        <motion.h1
          className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-2"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
        >
          Contact Us
        </motion.h1>
        <motion.p
          className="text-sm font-semibold"
          style={{ color: "#00C7EF" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          Home
        </motion.p>
      </section>

      {/* ── CONTACT BODY ── */}
      <section className="bg-white py-12 sm:py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">

          {/* Heading — fades up */}
          <motion.div
            className="text-center mb-10"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.6 }}
            transition={{ duration: 0.55, ease: "easeOut" }}
          >
            <h2 className="text-2xl sm:text-3xl font-extrabold mb-3" style={{ color: "#0F1030" }}>
              Get In Touch With Us
            </h2>
            <p className="text-gray-500 text-sm sm:text-base max-w-lg mx-auto leading-relaxed">
              For More Information About Our Products & Services, Please Feel Free To Drop Us An Email. Our Staff Always Be There To Help You Out. No Need Hesitate!
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 sm:gap-16">

            {/* ── LEFT — contact info slides in from left, items stagger ── */}
            <motion.div
              className="flex flex-col gap-7"
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              {contactInfo.map((item, i) => (
                <motion.div
                  key={item.label}
                  className="flex items-start gap-4"
                  initial={{ opacity: 0, x: -40 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: false, amount: 0.5 }}
                  transition={{ duration: 0.45, ease: "easeOut", delay: i * 0.12 }}
                >
                  <div
                    className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center mt-0.5"
                    style={{ backgroundColor: "#0F1030" }}
                  >
                    {item.icon}
                  </div>
                  <div>
                    <p className="font-bold text-sm sm:text-base" style={{ color: "#0F1030" }}>{item.label}</p>
                    {item.lines.map((line) =>
                      typeof line === "object" ? (
                        <a
                          key={line.text}
                          href={line.href}
                          className="block text-gray-500 text-sm mt-0.5 hover:text-cyan-500 transition-colors"
                        >
                          {line.text}
                        </a>
                      ) : (
                        <p key={line} className="text-gray-500 text-sm mt-0.5">{line}</p>
                      )
                    )}
                  </div>
                </motion.div>
              ))}
            </motion.div>

            {/* ── RIGHT — form slides in from right, fields stagger down ── */}
            <motion.div
              className="flex flex-col gap-4"
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              {/* Regular fields stagger in */}
              {formFields.map((f, i) => (
                <motion.div
                  key={f.name}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false, amount: 0.5 }}
                  transition={{ duration: 0.4, ease: "easeOut", delay: i * 0.1 }}
                >
                  <label className="block text-sm font-semibold mb-1.5" style={{ color: "#0F1030" }}>{f.label}</label>
                  <input
                    type={f.type}
                    name={f.name}
                    placeholder={f.placeholder}
                    value={form[f.name]}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 text-sm border outline-none focus:border-cyan-400 transition-colors"
                    style={{ borderColor: "#d1d5db", borderWidth: "1.5px" }}
                  />
                </motion.div>
              ))}

              {/* Message textarea */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.4, ease: "easeOut", delay: formFields.length * 0.1 }}
              >
                <label className="block text-sm font-semibold mb-1.5" style={{ color: "#0F1030" }}>Message</label>
                <textarea
                  name="message"
                  placeholder="Tell/ Write to us about..."
                  rows={4}
                  value={form.message}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 text-sm border outline-none focus:border-cyan-400 transition-colors resize-none"
                  style={{ borderColor: "#d1d5db", borderWidth: "1.5px" }}
                />
              </motion.div>

              {/* Submit button pops in last */}
              <motion.button
                onClick={handleSubmit}
                disabled={status === "sending"}
                className="w-full sm:w-auto px-10 py-3 text-sm font-bold tracking-wide text-white transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed"
                style={{ backgroundColor: "#0F1030" }}
                onMouseEnter={e => { if (status !== "sending") { e.currentTarget.style.backgroundColor = "#00C7EF"; e.currentTarget.style.color = "#0F1030"; }}}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = "#0F1030"; e.currentTarget.style.color = "#ffffff"; }}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.4, ease: "easeOut", delay: (formFields.length + 1) * 0.1 }}
                whileTap={{ scale: 0.97 }}
              >
                {status === "sending" ? "Sending..." : "Submit"}
              </motion.button>

              {/* Status messages */}
              {status === "success" && (
                <motion.p
                  className="text-sm font-semibold"
                  style={{ color: "#009a44" }}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  ✓ Message sent! We'll get back to you shortly.
                </motion.p>
              )}
              {status === "error" && (
                <motion.p
                  className="text-sm font-semibold text-red-500"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  ✗ Something went wrong. Please try again or call us directly.
                </motion.p>
              )}

            </motion.div>
          </div>
        </div>
      </section>

    </motion.div>
  );
}